import http from '@/plugins/axios/axios';

export default class RelatorioService {

    exportarDivergencias(requisicao) {
        return http.post('/api/relatorio/divergencias/pdf?origem=relatorio&total='+requisicao.idsFuncionarios.length, requisicao, {responseType: 'blob'});
    } 

    exportarDivergenciasXls(requisicao) {
        return http.post('/api/relatorio/divergencias/xls?origem=relatorio&total='+requisicao.idsFuncionarios.length, requisicao, {responseType: 'blob'});
    } 
    
    exportarEspelhoPonto(requisicao) {

        return http.post('/api/relatorio/espelho-ponto/pdf?origem=relatorio&total='+requisicao.idsFuncionarios.length, requisicao, {responseType: 'blob'});
    } 

    exportarHorasTrabalhadas(requisicao) {
        return http.post('/api/relatorio/horas-trabalhadas/pdf?origem=relatorio&total='+requisicao.idsFuncionarios.length, requisicao, {responseType: 'blob'});
    }
    
    exportarHorasExtrasAnalitico(requisicao) {
        return http.post('/api/relatorio/horas-extras-analitico/pdf?origem=relatorio&total='+requisicao.idsFuncionarios.length, requisicao, {responseType: 'blob'});
    }

    exportarInterjornada(requisicao) {
        return http.post('/api/relatorio/interjornada/pdf?origem=relatorio&total='+requisicao.idsFuncionarios.length, requisicao, {responseType: 'blob'});
    }

    exportarIntervaloAlmoco(requisicao) {
        return http.post('/api/relatorio/intervalo-almoco/pdf?origem=relatorio&total='+requisicao.idsFuncionarios.length, requisicao, {responseType: 'blob'});
    }

    exportarDomingosTrabalhados(requisicao) {
        return http.post('/api/relatorio/domingos-trabalhados/pdf?origem=relatorio&total='+requisicao.idsFuncionarios.length, requisicao, {responseType: 'blob'});
    }

    exportarSaldoBancoHoras(requisicao) {
        return http.post('/api/relatorio/saldo-banco-horas/pdf?origem=relatorio&total='+requisicao.idsFuncionarios.length, requisicao, {responseType: 'blob'});
    }

    exportarSaldoBancoHorasXls(requisicao) {
        return http.post('/api/relatorio/saldo-banco-horas/xls?origem=relatorio&total='+requisicao.idsFuncionarios.length, requisicao, {responseType: 'blob'});
    }

    exportarPontoExterno(requisicao) {
        return http.post('/api/relatorio/ponto-externo/pdf?origem=relatorio&total='+requisicao.idsFuncionarios.length, requisicao, {responseType: 'blob'});
    }

    exportarOcorrenciasJustificadasPdf(requisicao) {
        return http.post('/api/relatorio/ocorrencias-justificadas/pdf?origem=relatorio&total='+requisicao.idsFuncionarios.length, requisicao, {responseType: 'blob'});
    }

    exportarOcorrenciasJustificadasXls(requisicao) {
        return http.post('/api/relatorio/ocorrencias-justificadas/xls?origem=relatorio&total='+requisicao.idsFuncionarios.length, requisicao, {responseType: 'blob'});
    }

    exportarFuncionariosMarcacaoRelogio(requisicao) {
        return http.post('/api/relatorio/marcacao-funcionario-relogio/pdf?origem=relatorio&total='+requisicao.idsFuncionarios.length, requisicao, {responseType: 'blob'});
    }

    listarSolicitacoes(requisicao) {
        return http.get('/api/solicitacao-documento?idCnpj=' + requisicao.idCnpj + '&mes=' + requisicao.mes + '&ano=' + requisicao.ano);
    }

    listarPorIds(ids) {
        return http.post('/api/solicitacao-documento/listar-por-ids?fdb=f', ids);
    }

    buscarSolicitacao(id) {
        return http.get('/api/solicitacao-documento/buscar?fdb=f&id='+ id);
    }

    processar(requisicao) {
        return http.post('/api/solicitacao-documento', requisicao);
    }

    monitorarAFD(requisicao) {
        return http.post('/api/solicitacao-documento', requisicao);
    }
}